import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const AccessApi = createApi({
  reducerPath: "AccessApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/app/access`,
    prepareHeaders: (headers, { getState }) => {
      const { accessToken } = getState().user.tokens;

      if (accessToken) {
        headers.set("authorization", `Bearer ${accessToken}`);
      }

      headers.set("x-api-key", process.env.REACT_APP_SERVER_API_KEY);
      headers.set("Content-Type", "application/json");

      return headers;
    },
  }),
  endpoints: (build) => ({
    getApplications: build.query({
      query: () => ({
        url: `/applications`,
      }),
    }),
    getRoles: build.query({
      query: () => ({
        url: `/roles`,
      }),
    }),
  }),
});

export const { useGetApplicationsQuery, useGetRolesQuery } = AccessApi;